/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import {
    string, object, arrayOf, array, func, shape, bool,
    number,
} from 'prop-types';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core';
import Media from 'react-media';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIosTwoTone';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIosTwoTone';
import useSSRMediaQuery from '../../../../../../../helpers/hooks/useSSRMediaQuery';
import PDPAddonDetailUI from './PDPAddonDetailUI';
import ModalItemWrapper from '../../../../../GraphqlAddOnsPage/Partials/ModalItemWrapper';

const useStyle = makeStyles((theme) => ({
    sliderContainer: {
        position: 'relative',
        width: '100%',
        '& .slick-disabled': {
            display: 'none !important',
        },
        '&:hover': {
            '& .slick-next': {
                display: 'block !important',
                boxShadow: '2px 2px 4px rgb(47 47 47 / 15%)',
            },
            '& .slick-prev': {
                display: 'block !important',
                boxShadow: '2px 2px 4px rgb(47 47 47 / 15%)',
            },
            '& .slick-disabled': {
                display: 'none !important',
            },
        },
        '& .slick-track > .slick-slide:last-of-type': {
            marginRight: '4px !important',
        },
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0 auto',
            width: '100%',
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
            },
            '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
                height: '3px',
                backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                backgroundColor: 'transparent',
            },

        },
        '& .slick-slide': {
            display: 'inline-block',
            padding: 0,
            marginRight: '12px',
            verticalAlign: 'top',
        },
        '& .slick-next': {
            right: '1%',
            borderRadius: '50%',
            width: '30px',
            background: theme.palette.headerColor || '#E8F1ED',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: '0px',
            lineHeight: '0px',
            top: '30%',
            height: '30px',
            position: 'absolute',
            '& svg': {
                width: '0.7em',
                position: 'absolute',
                right: '15%',
                top: '1px',
            },
        },
        '& .slick-track': {
            display: 'flex',
        },
        '& .slick-prev': {
            left: '1%',
            borderRadius: '50%',
            zIndex: 9,
            width: '30px',
            background: theme.palette.headerColor || '#E8F1ED',
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            outline: 0,
            fontSize: '0px',
            lineHeight: '0px',
            top: '30%',
            height: '30px',
            position: 'absolute',
            '& svg': {
                width: '0.7em',
                position: 'absolute',
                right: '16%',
                top: '2px',
            },
        },
    },
    sliderWrapper: {
        paddingTop: '12px',
        position: 'relative',
        '@media screen and (max-width: 600px)': {
            overflow: 'scroll',
            position: 'relative',
            display: 'grid',
        },
    },
    addonContainer: {
        display: 'flex',
        overflowY: 'auto',
        padding: '0px 0px 8px',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '3px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    },
    addonInnerContainer: {
        width: '33%',
        minWidth: '107px',
        padding: '0px',
        marginRight: '10px',
    },
}));
const PDPSliderAddon = ({
    handleOpenModal,
    selectedItems,
    addOnHoverInfo,
    content,
    getSelectAddonsByGroup,
    selectItems,
    removeItems,
    openModal,
    modalItemList,
    typeItem,
    groupItemId,
    groupItemName,
    handleCloseModal,
    selectedItemsModal,
}) => {
    const sliderRef = useRef(null);
    const classes = useStyle();
    const deviceType = useSSRMediaQuery();
    const scrollRef = useRef();

    useEffect(() => {
        if (sliderRef?.current) {
            sliderRef.current.slickGoTo(0);
        }
        if (typeof window !== 'undefined' && scrollRef.current?.scrollTo) {
            const offsetLeft = scrollRef.current?.offsetLeft;
            const scrollLeft = scrollRef.current?.scrollLeft;
            if ((offsetLeft < scrollLeft)) {
                scrollRef.current.scrollTo({
                    top: 0,
                    left: offsetLeft,
                });
            }
        }
    }, []);

    const renderProduct = (isTrue = false) => (
        content.map((data) => {
            if (data.addons !== null) {
                const selectedGroupId = getSelectAddonsByGroup(data);
                return (
                    <div className={`${isTrue ? classes.addonInnerContainer : ''}`}>
                        <PDPAddonDetailUI
                            key={data.id}
                            addonData={data}
                            handleOpenModal={handleOpenModal}
                            selectedItems={selectedItems}
                            selectedGroupId={selectedGroupId}
                            addOnHoverInfo={addOnHoverInfo}
                            selectItems={selectItems}
                            isSlider
                            removeItems={removeItems}
                            wrapupAddonRedesign
                        />
                    </div>
                );
            }
            return null;
        })
    );
    return (
        <div className={`${classes.sliderWrapper} `}>
            <Media query={{ maxWidth: 600 }} defaultMatches={deviceType === 'mobile'}>
                {(matches) => (matches ? (
                    <div className={classes.addonContainer} ref={scrollRef}>
                        { renderProduct(true) }
                    </div>
                )
                    : (
                        <Slider
                            ref={sliderRef}
                            className={`${classes.sliderContainer}`}
                            draggable
                            dots={false}
                            infinite={false}
                            speed={500}
                            slidesToShow={4}
                            slidesToScroll={2}
                            nextArrow={<div><ArrowForwardIosIcon /></div>}
                            prevArrow={<div><ArrowBackIosIcon /></div>}
                        >
                            { content.map((data) => {
                                if (data.addons !== null) {
                                    const selectedGroupId = getSelectAddonsByGroup(data);
                                    return (
                                        <PDPAddonDetailUI
                                            key={data.id}
                                            addonData={data}
                                            handleOpenModal={handleOpenModal}
                                            selectedItems={selectedItems}
                                            selectedGroupId={selectedGroupId}
                                            addOnHoverInfo={addOnHoverInfo}
                                            selectItems={selectItems}
                                            removeItems={removeItems}
                                        />
                                    );
                                }
                                return null;
                            })}
                        </Slider>
                    )
                )}
            </Media>
            {/* Popup component */}
            { openModal && modalItemList && ((typeItem === 'addons' && modalItemList.length > 0))
                    && (
                        <ModalItemWrapper
                            selectItems={selectItems}
                            typeItem={typeItem}
                            modalItemList={modalItemList}
                            isOpen={openModal}
                            btnClose
                            onCloseModal={handleCloseModal}
                            groupItemId={groupItemId}
                            groupItemName={groupItemName}
                            selectedItems={selectedItemsModal}
                            wrapupAddonRedesign
                        />
                    )}
        </div>
    );
};

PDPSliderAddon.propTypes = {
    content: array.isRequired,
    addOnHoverInfo: arrayOf(shape({
        info_on_hover: string,
        product_sku_part_numbers: string,
        see_more_info: string,
    })).isRequired,
    getSelectAddonsByGroup: func.isRequired,
    groupItemId: number.isRequired,
    groupItemName: string.isRequired,
    handleCloseModal: func.isRequired,
    handleOpenModal: func.isRequired,
    modalItemList: object.isRequired,
    openModal: bool.isRequired,
    selectedItems: object.isRequired,
    selectedItemsModal: object.isRequired,
    selectItems: func.isRequired,
    typeItem: object.isRequired,
    removeItems: func.isRequired,
};

export default PDPSliderAddon;
